// extracted by mini-css-extract-plugin
export default {"brandImage":"SideMenu_brandImage__n0K08"};